export default __webpack_public_path__ + "db86cb28e5d4c0920ffb0ced2ae73cca.png";